import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'

import './styles/css/index.css'
import { Conversation } from './views'
import * as serviceWorker from './serviceWorker'

import i18n from './i18n'

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Router>
      <div id='page'>
        <Switch>
          <Route path={['/conversations/:shortId/participants/:participantShortId', '/c/:shortId/p/:participantShortId']} component={Conversation} />
          <Route path={['/conversations/:shortId', '/c/:shortId']} component={Conversation} />
          <Route>
            <h1>Not Found</h1>
            <p>This conversation does not exist</p>
          </Route>
        </Switch>
      </div>
    </Router>
  </I18nextProvider>,
  document.getElementById('root')
)

serviceWorker.unregister()
